<template>
  <BaseContainer class="dnnCloud-company-box" :loading="listLoading" :isHasPageFt="!listLoading">
    <template v-slot:hd>
      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-form :inline="true" :model="souchs" @submit.native.prevent>
          <el-form-item>
            <el-select v-model="regionCode" placeholder="大区" style="width: 150px" :clearable="true">
              <el-option v-for="item in regionCodeList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-input v-model="searchText" placeholder="企业名称" style="width: 200px" clearable
              @keyup.enter.native="getList(1)"></el-input>
          </el-form-item>

          <!-- <el-form-item>
            <el-select v-model="status" placeholder="企业状态" style="width:200px;" clearable>
              <el-option v-for="item in statusArr" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item> -->

          <el-form-item v-if="userInfo.type == 1 || userInfo.type == 0">
            <SelectCommon placeholder="客户经理" style="width: 150px" :clearable="true" apiPath="/tbAdminuser/manageList"
              :keys="{ label: 'name', value: 'id' }" :defaultVal="managerAdminuser" @change="
                (value, datas) =>
                  handleSelectCommonFilter(value, datas, 'managerAdminuser')
              " />
          </el-form-item>

          <el-form-item v-if="userInfo.type == 1 || userInfo.type == 0">
            <SelectCommon placeholder="客户成功经理" style="width: 150px" :clearable="true"  apiPath="/tbAdminuser/list"
              :params="{ type: 3 }"
              :keys="{ label: 'name', value: 'id' }" :defaultVal="successfulManager" @change="
                (value, datas) =>
                  handleSelectCommonFilter(value, datas, 'successfulManager')
              " />
          </el-form-item>

          <el-form-item v-if="userInfo.type == 1 || userInfo.type == 0">
            <SelectCommon placeholder="经销商" style="width: 150px" :clearable="true" apiPath="/tbAdminuser/list"
            :params="{ type: 4 }"
              :keys="{ label: 'name', value: 'id' }" :defaultVal="agencyManager" @change="
                (value, datas) =>
                  handleSelectCommonFilter(value, datas, 'agencyManager')
              " />
          </el-form-item>

          <el-form-item v-if="userInfo.type == 1 || userInfo.type == 0">
            <el-select v-model="distributionStatus" placeholder="是否分配" style="width: 120px" clearable>
              <el-option v-for="item in distribution" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item v-if="userInfo.type == 1 || userInfo.type == 0">
            <el-select v-model="gradeValue" placeholder="资质等级" multiple collapse-tags style="width: 150px" clearable>
              <el-option v-for="item in gradeArr" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" size="medium" v-on:click="getList(1)">查询</el-button>
          </el-form-item>

          <!-- 系统管理员可创建企业 -->
          <el-form-item>
            <el-button type="primary" size="medium" @click="handleAdd" class="adds"
              v-if="userInfo.type == 1 || userInfo.type == 0">新增</el-button>
          </el-form-item>

          <el-form-item v-if="userInfo.type == 1 || userInfo.type == 0">
            <el-button type="primary" size="medium" v-on:click="batchExport()" :loading="exportLoading">
              批量导出<span v-if="exportList.length"> ({{exportList.length}})</span>
            </el-button>
          </el-form-item>
          <el-form-item v-if="userInfo.type == 1 || userInfo.type == 0">
            <el-button type="primary" size="medium" v-on:click="batchImport()" :loading="importLoading">批量导入</el-button>
            <input type="file" id="importCompany" style="display:none" name="file" ref="clearFileModal" accept=".xls,.xlsx" @change="importCompanyFile($event)" />
          </el-form-item>
						
        </el-form>
      </el-col>
    </template>

    <template v-slot:main>
      <div class="tips">
        <span>覆盖率：</span><span class="blueNumber">{{ targetTotal }}</span>
        <span>甲级目标客户总数量：</span><span class="redNumber">{{ qualityTotal }}</span>
        <span>高校目标客户总数量：<span class="colleges">{{ collegesTotal }}</span></span>
      </div>
      <!--列表-->
      <el-table ref="companyTable" tooltip-effect="dark" :data="proList" row-key="id" highlight-current-row @selection-change="selsChange"
        @sort-change="handleSortChange" :height="maxTbHeight - 36" style="width: 100%" :header-cell-style="getRowClass">
        <el-table-column type="selection" :reserve-selection="true" width="55">
        </el-table-column>
        <el-table-column type="index" :index="indexMethod" label="序号" width="60">
          <template slot-scope="scope">
            <span>{{ (pageNumber - 1) * pageSize + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="id" label="企业编号（ID）" sortable="custom" min-width="150" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="regionCode" label="大区代号" sortable="custom" min-width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            <div v-if="scope.row.regionCode === '1'" class="gray">华东大区</div>
            <div v-if="scope.row.regionCode === '2'" class="gray">华北大区</div>
            <div v-if="scope.row.regionCode === '3'" class="gray">西北大区</div>
            <div v-if="scope.row.regionCode === '4'" class="gray">华南大区</div>
            <div v-if="scope.row.regionCode === '5'" class="gray">西南大区</div>
            <span v-if="!scope.row.regionCode">-</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="pic" header-align="center" align="center" min-width="min-150px" label="企业图标">
          <template slot-scope="scope">
            <img slot="reference" :src="scope.row.pic" class="tpimg" />
          </template>
        </el-table-column> -->
        <el-table-column prop="name" label="企业名称" sortable="custom" min-width="240" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="grade" label="资质等级" sortable="custom" min-width="110" show-overflow-tooltip>
          <template slot-scope="scope">
            <div v-if="scope.row.grade == '1'" class="blue">综合甲</div>
            <div v-if="scope.row.grade === '2'" class="blue">公路甲</div>
            <div v-if="scope.row.grade === '3'" class="blue">市政甲</div>
            <div v-if="scope.row.grade === '4'" class="blue">公路市政甲</div>
            <div v-if="scope.row.grade === '5'" class="purple">公路乙</div>
            <div v-if="scope.row.grade === '6'" class="purple">市政乙</div>
            <div v-if="scope.row.grade === '7'" class="purple">公路市政乙</div>
            <div v-if="scope.row.grade === '9'" class="purple">高校</div>
            <div v-if="scope.row.grade === '10'" class="purple">施工单位</div>
            <div v-if="scope.row.grade === '8'" class="other">其他</div>
          </template>
        </el-table-column>
        <el-table-column prop="natrue" label="企业性质" sortable="custom" min-width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            {{
              scope.row.natrue === "1"
              ? "央企"
              : scope.row.natrue === "2"
                ? "国企"
                : scope.row.natrue === "3"
                  ? "民营上市"
                  : scope.row.natrue === "4"
                    ? "民营"
                    : scope.row.natrue === "5"
                      ? "高校"
                      : "-"
            }}
          </template>
        </el-table-column>
        <el-table-column prop="userScale" label="用户规模" sortable="custom" min-width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.userScale || "-" }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="showname" label="地区" sortable="custom" min-width="140" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.showname || "-" }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="intime" label="添加日期" min-width="180" show-overflow-tooltip>
            </el-table-column> -->
        <!-- <el-table-column label="公司管理员" sortable="custom" min-width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{scope.row.managername?scope.row.managername:'-'}}</span>
          </template>
        </el-table-column> -->
        <el-table-column label="客户分级" prop="level" sortable="custom" min-width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-rate :value="Number(scope.row.level)" :max="Number(scope.row.level)"></el-rate>
            <span v-if="!scope.row.level">-</span>
          </template>
        </el-table-column>
        <el-table-column label="客户经理" min-width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{
              scope.row.managerAdminuserName
              ? scope.row.managerAdminuserName
              : "-"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="客户成功经理" min-width="110" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{
              scope.row.successfulManagerName
              ? scope.row.successfulManagerName
              : "-"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="经销商" min-width="70" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{
              scope.row.agencyManagerName
              ? scope.row.agencyManagerName
              : "-"
            }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="status" width="100" label="企业状态" show-overflow-tooltip>
          <template slot-scope="scope">
            <div v-if="scope.row.status == 0" class="visit_gray">初始</div>
            <div v-if="scope.row.status == 1" class="orange">拜访</div>
            <div v-if="scope.row.status == 2" class="purple_line">试用</div>
            <div v-if="scope.row.status == 3" class="blue_line">正式</div>
          </template>
        </el-table-column>

        <el-table-column label="操作" min-width="100" style="text-algin: center">
          <template slot-scope="scope">
            <el-tooltip effect="dark" content="详情" placement="top" class="caozuo">
              <span class="dnnfont iconfile-search" @click="handleCom(scope.$index, scope.row)"></span>
            </el-tooltip>

            <!-- 创建人&&没有订单 -->
            <!-- 系统管理员直接可删 -->
            <el-tooltip effect="dark" v-if="scope.row.delFlg !== '0'" content="删除"
              placement="top" class="caozuo">
              <span class="dnnfont icondelete" @click="handleDel(scope.$index, scope.row)"></span>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>

      <target-custom-dialog ref="targetcustomdialogRef" @getList="getList"></target-custom-dialog>

      <!--新增界面-->
      <el-dialog class="model-edit" title="新增" width="850px" :visible.sync="addFormVisible" :close-on-click-modal="false"
        @close="closedialog">
        <el-form :model="addForm" v-if="addFormVisible" label-width="80px" :rules="addFormRules" ref="addForm"
          @submit.native.prevent>
          <el-row>
            <el-col :span="22">
              <el-form-item label="企业名称" prop="name">
                <!-- <el-input v-model="addForm.name" auto-complete="off" placeholder="请输入"></el-input> -->
                <el-autocomplete style="width: 100%" placeholder="请输入" clearable v-model="addForm.name"
                  :fetch-suggestions="querySearch" :trigger-on-focus="false" @select="handleSelect"></el-autocomplete>
              </el-form-item>
            </el-col>

            <el-col :span="22">
              <el-form-item label="地区" prop="showname">
                <el-input v-model="addForm.showname" auto-complete="off" placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="22">
              <el-form-item label="客户地址" required>
                <GisCommon :selected="selected" :address="address" :lonLat="addForm.longitudeAndLatitude" @backPram="backPram"></GisCommon>
              </el-form-item>
            </el-col>

            <el-col :span="22">
              <el-form-item label="客户经理" required>
                <SelectCommon placeholder="客户经理" style="width: 100%" :clearable="true" apiPath="/tbAdminuser/manageList"
                  :keys="{ label: 'name', value: 'id' }" @change="
                    (value, datas) =>
                      handleSelectCommon(value, datas, 'managerAdminuser')
                  " />
              </el-form-item>
            </el-col>

            <el-col :span="22">
              <el-form-item label="企业图标" required>
                <el-upload ref="upload" :auto-upload="false" :on-change="imgPreview" class="avatar-uploader"
                  :action="upload.postURL" :show-file-list="false">
                  <img v-if="imageUrl" :src="imageUrl" class="avatar" />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <div slot="footer" class="dialog-footer" style="text-align: center">
          <el-button @click.native="handerClose('addFormVisible', 'addForm')">取消</el-button>
          <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
        </div>
      </el-dialog>

      <!--编辑界面-->
      <el-dialog class="model-edit" title="编辑" :visible.sync="editFormVisible" :close-on-click-modal="false">
        <el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm" @submit.native.prevent>
          <el-row>
            <el-col :span="22">
              <el-form-item label="图片">
                <el-upload ref="upload" :auto-upload="false" :on-change="imgPreview" class="avatar-uploader"
                  :action="upload.postURL" :show-file-list="false">
                  <img v-if="editImageUrl" :src="editImageUrl" class="avatar" />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="22">
              <el-form-item label="企业名称" prop="name">
                <el-input v-model="editForm.name" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="22">
              <el-form-item label="地区" prop="showname">
                <el-input v-model="editForm.showname" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align: center">
          <el-button @click.native="editFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
        </div>
      </el-dialog>

      <el-dialog class="model-edit" title="选择人员" v-if="orderVisible" :visible.sync="orderVisible"
        :close-on-click-modal="false">
        <el-col :span="24" class="toolbar" style="padding-bottom: 0px; border: 1px solid #dfe6ec">
          <el-form :inline="true" :model="souchs2" @submit.native.prevent>
            <el-select v-model="value2" placeholder="请选择" @change="changeSouch2" style="width: 120px">
              <el-option v-for="item in optionsSouch2" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <el-form-item>
              <el-input v-show="disSouch" v-model="proName2" style="width: 200px"
                @keyup.enter.native="getUser(1)"></el-input>
              <el-select v-show="disinvit" v-model="souchs2.invitValue" placeholder="请选择" style="width: 200px" clearable>
                <el-option v-for="item in inviValues" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <el-select v-show="disSofttype" v-model="souchs2.softtype" placeholder="请选择" style="width: 200px" clearable>
                <el-option v-for="item in softtypes" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <el-date-picker v-show="disTime1" style="width: 200px" v-model="souchs2.fromtime" format="yyyy-MM-dd"
                value-format="yyyy-MM-dd" type="date" placeholder="注册开始时间">
              </el-date-picker>
              <el-date-picker v-show="disTime2" style="width: 200px" v-model="souchs2.totime" format="yyyy-MM-dd"
                value-format="yyyy-MM-dd" type="date" placeholder="注册结束时间">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" v-on:click="getUser(1)">查询</el-button>
            </el-form-item>
          </el-form>
          <el-tag :key="tag2" v-for="tag2 in dynamicTags2" closable :disable-transitions="false"
            @close="handleClose2(tag2)">
            {{ tag2 }}
          </el-tag>
          <el-button v-if="dynamicTags2 != ''" class="button-new-tag" size="small" @click="delTags2">清除标签</el-button>
        </el-col>

        <!--用户列表-->
        <el-table :row-key="(row) => row.id" :data="userList" highlight-current-row v-loading="userLoading"
          style="width: 100%" ref="userList" :header-cell-style="getRowClass" @current-change="handleSelectionChange"
          @selection-change="handleUserSelectionChange">
          <!-- <el-table-column label="操作" width="80">
                <template slot-scope="scope">
                  <el-checkbox v-model="scope.row.checked" @change="changeFun"></el-checkbox> 
                </template>
              </el-table-column> -->
          <el-table-column :reserve-selection="true" type="selection" width="55">
          </el-table-column>
          <el-table-column prop="phone" label="账号" min-width="130">
          </el-table-column>
          <el-table-column prop="name" label="姓名" min-width="100" xshow-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="softtype" label="软件类型" min-width="120" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="company" label="企业" min-width="160" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="intime" label="注册时间" min-width="160" show-overflow-tooltip>
          </el-table-column>
        </el-table>
        <!--工具条-->
        <el-col :span="24" class="toolbar" style="border: 1px solid #dfe6ec; margin-top: 0">
          <el-pagination layout=" prev, pager, next" :current-page="pageNumber2" @current-change="handleCurrentChange2"
            :page-size="pageSize2" :total="total2" style="float: right">
          </el-pagination>
        </el-col>
        <div slot="footer" class="dialog-footer" style="text-align: center">
          <el-button @click.native="orderVisible = false">取消</el-button>
          <el-button type="primary" @click.native="clickUserSelection" :loading="orderLoading">确定</el-button>
        </div>
      </el-dialog>

      <Admin :adminVisible="adminVisible" v-if="adminVisible" :companyId="companyId" :UserSelection="UserSelection"
        @adminVisibleClose="adminVisibleClose" @addAdmin="addAdmin" @orderUserSubmit="orderUserSubmit" />
    </template>

    <template v-slot:ft>
      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination layout="sizes, prev, pager, next" :page-sizes="[10, 20, 30, 50, 100]"
          :current-page.sync="pageNumber" @current-change="handleCurrentChange" @size-change="handleSizeChange"
          :page-size="pageSize" :total="total" style="float: right">
        </el-pagination>
      </el-col>
    </template>
  </BaseContainer>
</template>
<script>
import { mapGetters } from "vuex";
import {
  API__code,
  API_User,
  API_Urls,
  API_Admin,
  API_Common,
  API__Position,
} from "../../../api/index.js";
import GisCommon from "@/components/GisCommon";
import Admin from "../companys/addAdmin";
import BaseContainer from "@/components/BaseContainer";
import axios from "axios";
import SelectCommon from "@/components/SelectCommon";
import fitTableHeight from "@/mixins/fitTableHeight.js";
import TargetCustomDialog from "./targetCustomDialog.vue";
export default {
  mixins: [fitTableHeight],
  data() {
    // 校验企业名称是否唯一
    var validatorCompany = async (rule, value, callback) => {
      if (!this.addForm.name) {
        callback("请输入企业名称");
      } else {
        let res = await this.checkCompany(this.addForm.name);
        !res ? callback("企业名称已存在") : callback();
      }
    };
    return {
      beformAddImg: "",
      editImageUrl: "",
      adminVisible: false,
      imageUrl: "",
      upload: {
        fileList: this.fileList,
        picIds: [],
        postURL: API_Common.setCompanyPic(), //post地址
        dialogImageUrl: "", // 文件地址
        dialogVisible: false, // 上传文件loading
        data: {
          mode: "save",
          token: this.token,
          checkCode: this.checkCode,
          type: 1,
        },
      },

      disSouch: true,
      disinvit: false,
      disSofttype: false,
      disTime1: false,
      disTime2: false,
      proName2: "",
      dynamicTags2: [],
      optionsSouch2: [
        { value: "账号", label: "账号" },
        { value: "姓名", label: "姓名" },
        { value: "企业", label: "企业" },
        { value: "软件类型", label: "软件类型" },
        { value: "邀请状态", label: "邀请状态" },
        { value: "开始日期", label: "开始日期" },
        { value: "结束日期", label: "结束日期" },
      ],
      value2: "",
      inviValues: [],
      softtypes: [],

      proName: "",
      dynamicTags: [],
      options: [
        { value: "ID", label: "ID" },
        { value: "企业名称", label: "企业名称" },
        { value: "管理员", label: "管理员" },
      ],
      value: "",

      rname: "",
      companyId: "",
      orderLoading: false,
      userLoading: false,
      orderVisible: false,
      pageNumber2: 1,
      pageSize2: 10,
      total2: 0,
      userList: [],
      souchs2: {
        name: "",
        phone: "",
        company: "",
        invitestatus: "",
        softtype: "",
        fromtime: "",
        totime: "",
      },
      flag: false,
      checkUserId: "",
      checkUserIdOld: "",
      token: this.token,
      checkCode: this.checkCode,
      id: this.id,
      souchs: {
        name: "",
      },
      total: 0,
      pageSize: this.$route.query.pageSize ? Number(this.$route.query.pageSize) : 20,
      pageNumber: 1,
      proList: [],
      listLoading: false,
      sels: [],
      exportList: [], // 跨页保留需要导出的多选数据
      exportLoading: false,
      needClearSel: false,
      importLoading: false,

      addFormVisible: false,
      addLoading: false,
      addForm: {
        name: "",
        showname: "",
        province: "",
        city: "",
        district: "",
        longitudeAndLatitude: "",
        addressInfo: "",
        managerAdminuser: "",
        managerAdminuserName: "",
      },

      addFormRules: {
        name: [
          // { required: true, message: '请输入企业名称', trigger: 'blur' },
          { required: true, validator: validatorCompany, trigger: "change" },
        ],
        showname: [{ required: true, message: "请输入地区", trigger: "blur" }],
      },

      editFormVisible: false,
      editLoading: false,
      editForm: {
        name: "",
      },
      editFormRules: {
        name: [{ required: true, message: "请输入企业名称", trigger: "blur" }],
      },
      orderType: "",
      orderStr: "",

      userSelection: [],
      UserSelection: [],
      searchText: this.$route.query.searchText
        ? this.$route.query.searchText
        : "",
      selected: {
        province: "320000",
        city: "320100",
        area: "320115",
        town: "320115010",
      }, // ['110000', '130200', '140100']
      address: "",

      comLists: [],

      statusArr: [
        { value: 1, label: "拜访" },
        { value: 2, label: "试用 " },
        { value: 3, label: "正式" },
      ],
      gradeArr: [
        { value: '1', label: "综合甲" },
        { value: '2', label: "公路甲 " },
        { value: '3', label: "市政甲" },
        { value: '4', label: "公路市政甲" },
        { value: '5', label: "公路乙" },
        { value: '6', label: "市政乙" },
        { value: '7', label: "公路市政乙" },
        { value: '9', label: "高校" },
        { value: '10', label: "施工单位" },
        { value: '8', label: "其他" },
      ],
      gradeValue:[],
      status: this.$route.query.status ? this.$route.query.status : "",
      distribution: [
        { value: "0", label: "未分配" },
        { value: "1", label: "已分配" },
      ],
      distributionStatus: this.$route.query.distributionStatus
        ? this.$route.query.distributionStatus
        : "",
      managerAdminuser: this.$route.query.managerAdminuserName,
      successfulManager:'',
      agencyManager:"",
      targetTotal: 0, //总数
      qualityTotal: 0, //甲级总数
      collegesTotal: 0,
      regionCodeList: [
        {
          value: "1",
          label: "华东大区",
        },
        {
          value: "2",
          label: "华北大区",
        },
        {
          value: "3",
          label: "西北大区",
        },
        {
          value: "4",
          label: "华南大区",
        },
        {
          value: "5",
          label: "西南大区",
        },
      ],
      regionCode: "",
    };
  },

  computed: {
    ...mapGetters(["userInfo"]),
  },

  components: {
    BaseContainer,
    SelectCommon,
    Admin,
    GisCommon,
    TargetCustomDialog,
  },
  methods: {
    // 批量导出
		batchExport() {
			if (!this.exportList.length) {
				this.$message.error("请先勾选要导出的企业");
				return;
			}
			let param = {
				ids: this.exportList.map((item) => item.id),
			};
			this.exportLoading = true;
			API_User.exportCompanyExcel(param)
				.then((res) => {
					if (res.data.type && res.data.type.indexOf("json") > -1) {
						// 后端返回JSON，说明导出出错（如登录过期）
						const reader = new FileReader();
						reader.onload = () => {
							const result = JSON.parse(reader.result);
							this.$message.error(result.message || "导出失败");
						};
						reader.readAsText(res.data);
					} else {
						const blob = new Blob([res.data], {
							type: "application/vnd.ms-excel",
						});
						const fileName = "目标客户池_" + Date.now() + ".xls";
						const elink = document.createElement("a");
						elink.download = fileName;
						elink.style.display = "none";
						elink.href = URL.createObjectURL(blob);
						document.body.appendChild(elink);
						elink.click();
						URL.revokeObjectURL(elink.href);
						document.body.removeChild(elink);
						this.$message.success("导出成功");
					}
					this.exportLoading = false;
				})
				.catch((err) => {
					this.$message.error("导出失败，请稍后重试！");
					this.exportLoading = false;
				});
		},
    // 批量导入：触发文件选择
    batchImport() {
      this.$refs.clearFileModal.click();
    },
    // 选择文件后上传导入
    importCompanyFile(fileEvent) {
      const file = fileEvent.target.files[0];
      if (!file) {
        this.$message.error("请选择文件！");
        return;
      }
      if (!/\.(xls|xlsx)$/i.test(file.name)) {
        this.$message.error("请选择xls或xlsx格式的文件！");
        this.$refs.clearFileModal.value = "";
        return;
      }
      // 转义，防止Excel内容中的特殊字符破坏弹窗HTML
      const esc = function (val) {
        return String(val == null ? "" : val)
          .replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;");
      };
      let formData = new FormData();
      formData.append("file", file);
      this.importLoading = true;
      API_User.importCompanyExcel(formData)
        .then((res) => {
          console.log("导入接口返回：", res.data); // TODO: 联调确认后可删除
          let data = res.data || {};
          // 兼容后端整体返回JSON字符串的情况
          if (typeof data === "string") {
            try {
              data = JSON.parse(data);
            } catch (e) {}
          }
          if (data.code == API__code.SUCCESS) {
            let detail = data.data || {};
            // 兼容data为JSON字符串的情况
            if (typeof detail === "string") {
              try {
                detail = JSON.parse(detail);
              } catch (e) {
                detail = {};
              }
            }
            // 兼容faillist/failList两种字段名
            const failList = detail.faillist || detail.failList || [];
            if (failList.length > 0 || Number(detail.fail) > 0) {
              // 存在导入失败的数据，弹窗列出失败明细
              let html = "<div>" + esc(data.message) + "</div>";
              if (!failList.length) {
                html += "<div>失败数：" + esc(detail.fail) + "</div>";
              }
              failList.forEach((item) => {
                html += "<div>第" + esc(item.rowNum) + "行 " + esc(item.companyName) + "，" + esc(item.reason) + "</div>";
              });
              this.$alert(html, "部分数据导入失败", {
                customClass: "import-fail-alert",
                dangerouslyUseHTMLString: true,
                confirmButtonText: "知道了",
              });
            } else {
              // 全部导入成功，直接提示message
              this.$message.success(data.message || "导入成功");
            }
            this.getList(1); // 刷新列表（回到第一页并清空已选项）
          } else {
            this.$message.error(data.message || "导入失败");
          }
          this.importLoading = false;
          this.$refs.clearFileModal.value = ""; // 复位，保证可重复选择同一文件
        })
        .catch((err) => {
          this.$message.error("导入失败，请稍后重试！");
          this.importLoading = false;
          this.$refs.clearFileModal.value = "";
        });
    },

    // 初始化搜索信息
    initSearchParams() {
      let { regionCode, searchText,managerAdminuser,successfulManager,agencyManager,distributionStatus,gradeValue } = this.$route.query;
      this.regionCode= regionCode || ''
      this.searchText= searchText || ''
      this.managerAdminuser= managerAdminuser || ''
      this.successfulManager= successfulManager || ''
      this.agencyManager= agencyManager || ''
      this.distributionStatus= distributionStatus || ''
      gradeValue = typeof gradeValue === 'number' ? gradeValue+'' : gradeValue
      this.gradeValue= gradeValue ? gradeValue.split(',') : []
    },
    // 客户经理过滤
    handleSelectCommonFilter(value, datas, key) {
      this[key]=value[0]
    },

    // el-autocomplete
    querySearch(queryString, cb) {
      var comLists = this.comLists;
      var results = queryString
        ? comLists.filter(this.createFilter(queryString))
        : comLists;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },

    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },

    loadCompany() {
      this.getCompanySearch();
    },

    handleSelect(item) {
      console.log("select==", this.addForm.name, item);
    },

    // 根据名称模糊查询企业列表
    getCompanySearch() {
      API_User.getCompanySearch()
        .then((res) => {
          if (res.data.code == API__code.SUCCESS) {
            let data = res.data.data;
            this.comLists = data.map((item) => ({ value: item }));
            sessionStorage.setItem("comLists", JSON.stringify(this.comLists));
          } else {
            this.$message.error(res.data.message);
            if (res.data.code == 403) {
              this.$router.push({ path: "loginAdmin" });
            }
          }
        })
        .catch((err) => { });
    },

    // 校验公司名称是否唯一：true唯一 false 不唯一
    checkCompany(name) {
      return API_User.checkCompanyUnique({ name })
        .then((res) => {
          console.log("ressss--", res);
          if (res.data.code == 401) {
            return false;
          }
          return true;
        })
        .catch((err) => {
          return true;
        });
    },

    closedialog() {
      this.selected = {
        province: "320000",
        city: "320100",
        area: "320115",
        town: "320115010",
      };
      this.addForm.longitudeAndLatitude = "";
      this.addForm.addressInfo = "";
      this.addForm.managerAdminuser = "";
      this.imageUrl = "";
      this.beformAddImg = "";
    },
    handleSelectCommon(value, datas, key) {
      this.addForm.managerAdminuser = value[0];
    },

    addAdmin() {
      this.getUser();
      this.userSelection = [];
      this.orderVisible = true;
    },

    adminVisibleClose(type) {
      this.adminVisible = false;
      if (type == 1) {
        this.getList();
      }
    },
    handleUserSelectionChange(rowSelect) {
      var jc = [];
      var row = [];
      for (var p in rowSelect) {
        if (jc.indexOf(rowSelect[p].id) == -1) {
          jc.push(rowSelect[p].id);
          row.push(rowSelect[p]);
        }
      }
      this.userSelection = row;
    },

    imgPreview(file, fileList) {
      let fileName = file.name;
      let regex = /(.jpg|.jpeg|.gif|.png|.bmp)$/;
      if (regex.test(fileName.toLowerCase())) {
        this.beformAddImg = file;
        this.imageUrl = URL.createObjectURL(file.raw);
        this.editImageUrl = URL.createObjectURL(file.raw);
      } else {
        this.$message.error("请选择图片文件");
      }
    },
    handleSortChange: function (val) {
      if (val) {
        if (val.prop == "id") {
          this.orderStr = "idpx";
        } else if (val.prop == "name") {
          this.orderStr = "namepx";
        } else if (val.prop == "managername") {
          this.orderStr = "managernamepx";
        } else if (val.prop == "showname") {
          this.orderStr = "shownamepx";
        } else if (val.prop == "regionCode") {
          this.orderStr = "regionCodepx";
        } else if (val.prop == "grade") {
          this.orderStr = "gradepx";
        } else if (val.prop == "natrue") {
          this.orderStr = "natruepx";
        } else if (val.prop == "userScale") {
          this.orderStr = "userScalepx";
        } else if (val.prop == "level") {
          this.orderStr = "levelpx";
        }
        if (val.order == "descending") {
          this.orderType = "desc";
        } else {
          this.orderType = "asc";
        }
      }
      this.getList();
    },
    changeSouch2: function (val) {
      this.disSouch = false;
      this.disinvit = false;
      this.disSofttype = false;
      this.disTime1 = false;
      this.disTime2 = false;
      if (val == "账号") {
        this.proName2 = this.souchs2.phone;
        this.disSouch = true;
      } else if (val == "姓名") {
        this.proName2 = this.souchs2.name;
        this.disSouch = true;
      } else if (val == "企业") {
        this.proName2 = this.souchs2.company;
        this.disSouch = true;
      } else if (val == "软件类型") {
        this.disSofttype = true;
      } else if (val == "邀请状态") {
        this.disinvit = true;
      } else if (val == "开始日期") {
        this.disTime1 = true;
      } else if (val == "结束日期") {
        this.disTime2 = true;
      }
    },
    handleClose2(tag) {
      if (tag == "账号") {
        this.souchs2.phone = "";
        if (this.value2 == "账号") {
          this.proName2 = "";
        }
      }
      if (tag == "姓名") {
        this.souchs2.name = "";
        if (this.value2 == "姓名") {
          this.proName2 = "";
        }
      }
      if (tag == "企业") {
        this.souchs2.company = "";
        if (this.value2 == "企业") {
          this.proName2 = "";
        }
      }
      if (tag == "软件类型") {
        this.souchs2.softtype = "";
      }
      if (tag == "邀请状态") {
        this.souchs2.invitValue = "";
      }
      if (tag == "开始日期") {
        this.souchs2.fromtime = "";
      }
      if (tag == "结束日期") {
        this.souchs2.totime = "";
      }
      this.dynamicTags2.splice(this.dynamicTags2.indexOf(tag), 1);
    },
    delTags2: function () {
      this.souchs2 = {};
      this.proName2 = "";
      this.value2 = "";
      this.dynamicTags2 = [];
      this.pageNumber2 = 1;
      this.getUser();
    },

    handleCurrentChange2(val) {
      this.pageNumber2 = val;
      this.getUser();
    },
    clickUserSelection() {
      let _this = this;
      var list = Object.assign([], this.userSelection);
      this.UserSelection = list;
      this.orderVisible = false;
    },
    orderUserSubmit: function (rows) {
      console.log(rows);
      let _this = this;
      // if(!this.checkUserId){
      //   this.$message.error('请选择用户！');
      //   return;
      // }
      var list = Object.assign([], rows);

      var UserIds = [];
      for (var p in list) {
        UserIds.push(list[p].id);
      }

      let param = {
        token: this.token,
        checkCode: this.checkCode,
        companyid: this.companyId,
        userid: UserIds.toString(),
      };
      API_User.setCompanyManager(param)
        .then((res) => {
          if (res.data.code == API__code.SUCCESS) {
            this.$message({
              message: "保存成功",
              type: "success",
            });
            this.adminVisible = false;
            this.getList();
          } else {
            _this.$message.error(res.data.message);
            if (res.data.code == 403) {
              _this.$router.push({ path: "loginAdmin" });
            }
          }
        })
        .catch((err) => {
          _this.$message.error("数据丢失，试试重新登陆！");
        });
    },
    changeFun(e, val) {
      if (!e) {
        this.checkUserId = "";
      }
      if (e && !this.flag) {
        this.checkUserId = this.checkUserIdOld;
      }
      this.flag = false;
    },
    handleSelectionChange(row) {
      this.flag = true;
      this.userList.forEach((item) => {
        if (item.id !== row.id) {
          item.checked = false;
        }
        if (item.id == row.id) {
          item.checked = true;
        }
      });
      if (row.name == null) {
        row.name = "";
      }
      if (row.phone == null) {
        row.phone = "";
      }
      this.checkUserId = row.id;
      this.checkUserIdOld = row.id;
    },
    getUser: function (val) {
      let _this = this;
      if (this.value2 == "账号") {
        this.souchs2.phone = this.proName2;
      }
      if (this.value2 == "企业") {
        this.souchs2.company = this.proName2;
      }
      if (this.value2 == "姓名") {
        this.souchs2.name = this.proName2;
      }
      var flag2 = true;
      if (val == 1) {
        this.pageNumber2 = 1;
        if (this.value2) {
          if (this.dynamicTags2.length > 0) {
            for (var i = 0; i < this.dynamicTags2.length; i++) {
              if (this.value2 == this.dynamicTags2[i]) {
                flag2 = false;
              }
            }
          }
          if (flag2) {
            this.dynamicTags2.push(this.value2);
          }
        }
      }
      let param = {
        token: this.token,
        checkCode: this.checkCode,
        pageNumber: this.pageNumber2,
        pageSize: this.pageSize2,
        listType: "page",
        userType: "",
        // searchStr:this.souchs2.name,
        username: this.souchs2.name,
        phone: this.souchs2.phone,
        company: this.souchs2.company,
        registertimefrom: this.souchs2.fromtime,
        registertimeto: this.souchs2.totime,
        softtype: this.souchs2.softtype,
        invitestatus: this.souchs2.invitValue,
      };
      API_User.userList(param)
        .then((res) => {
          if (res.data.code == API__code.SUCCESS) {
            if (res.data.data) {
              _this.total2 = res.data.data.totalRow;
              _this.userList = res.data.data.list;
            }
          } else {
            _this.$message.error(res.data.message);
            if (res.data.code == 403) {
              _this.$router.push({ path: "loginAdmin" });
            }
          }
        })
        .catch((err) => {
          _this.$message.error("数据丢失，试试重新登陆！");
        });
    },
    handleUser: function (index, row) {
      this.companyId = "";
      this.companyId = row.id;
      this.rname = "";
      this.rname = row.managerid;
      (this.souchs2 = {}), (this.dynamicTags2 = []);
      this.proName2 = "";
      this.value2 = "";
      this.adminList = [];
      this.adminVisible = true;
    },
    editSubmit: function () {
      let _this = this;

      if (!this.editForm.name) {
        this.$message.error("请输入企业名称!");
        return;
      }

      if (!this.editImageUrl && !this.beformAddImg) {
        this.$message.error("请上传图片!");
        return;
      }

      if (this.beformAddImg) {
        let var_this = this;
        let formData = new FormData();
        formData.append("pic", this.beformAddImg.raw);
        formData.append("token", this.token);
        formData.append("checkCode", this.checkCode);
        formData.append("showpicid", this.editForm.showpicid);
        formData.append("mode", "save");
        let config = {
          "Content-Type": "multipart/form-data",
        };
        axios
          .post(this.upload.postURL, formData, config)
          .then(function (res) {
            if (res.data.code == API__code.SUCCESS) {
              _this.editSave(res.data.data);
              _this.$refs.upload.clearFiles();
            } else {
              _this.$message.error(res.data.message);
              if (res.data.code == 403) {
                _this.$router.push({ path: "loginAdmin" });
              }
              return;
            }
          })
          .catch(function (error) {
            console.log(error);
            return;
          });
      } else {
        this.editSave();
      }
    },
    editSave: function (val) {
      let param;
      if (val) {
        var newlbtPath = val.pic;
        var newId = val.id;
        param = {
          token: this.token,
          checkCode: this.checkCode,
          mode: "",
          id: this.editForm.id,
          name: this.editForm.name,
          logoid: newlbtPath,
          showpicid: newId,
          showname: this.editForm.showname,
        };
      } else {
        param = {
          token: this.token,
          checkCode: this.checkCode,
          mode: "",
          id: this.editForm.id,
          name: this.editForm.name,
          showname: this.editForm.showname,
        };
      }
      this.editLoading = true;
      API_User.addCompanyList(param)
        .then((res) => {
          if (res.data.code == API__code.SUCCESS) {
            this.$message({
              message: "保存成功",
              type: "success",
            });
            this.getList();
            this.editFormVisible = false;
          } else {
            this.$message.error(res.data.message);
            if (res.data.code == 403) {
              this.$router.push({ path: "loginAdmin" });
            }
          }
          this.editLoading = false;
        })
        .catch((err) => {
          this.$message.error("数据丢失，试试重新登陆！");
          this.editLoading = false;
        });
    },

    addSubmit() {
      let _this = this;
      this.$refs["addForm"].validate((valid) => {
        if (valid) {
          if (this.addLoading) {
            return;
          }
          if (!this.beformAddImg) {
            this.$message.error("请上传图片!");
            return;
          }

          if (!this.addForm.longitudeAndLatitude) {
            this.$message.error("请在GIS地图中确认位置!");
            return;
          }

          if (!this.addForm.managerAdminuser) {
            this.$message.error("请选择客户经理");
            return;
          }

          this.addLoading = true;
          let formData = new FormData();
          formData.append("pic", this.beformAddImg.raw);
          formData.append("token", this.token);
          formData.append("checkCode", this.checkCode);
          formData.append("mode", "save");
          let config = {
            "Content-Type": "multipart/form-data",
          };

          axios
            .post(this.upload.postURL, formData, config)
            .then(function (res) {
              if (res.data.code == API__code.SUCCESS) {
                _this.addSubmit2(res.data.data);
                _this.$refs.upload.clearFiles();
              } else {
                _this.$message.error(res.data.message);
                if (res.data.code == 403) {
                  _this.$router.push({ path: "loginAdmin" });
                }
                return;
              }
            })
            .catch(function (error) {
              console.log(error);
              return;
            });
        }
      });
    },

    addSubmit2(val) {
      var newlbtPath = val.pic;
      var newId = val.id;
      let param = {
        token: this.token,
        checkCode: this.checkCode,
        mode: "save",
        name: this.addForm.name,
        logoid: newlbtPath,
        showpicid: newId,
        showname: this.addForm.showname,
        createUser: this.userInfo.id,
        province: this.addForm.province,
        city: this.addForm.city,
        district: this.addForm.district,
        longitudeAndLatitude: this.addForm.longitudeAndLatitude,
        addressInfo: this.addForm.addressInfo,
        managerAdminuser: this.addForm.managerAdminuser,
        isbinding: 0,
      };
      API_User.addCompanyList(param)
        .then((res) => {
          if (res.data.code == API__code.SUCCESS) {
            this.$message({
              message: "保存成功",
              type: "success",
            });
            this.getList();
            this.addFormVisible = false;
            this.resetForm("addForm");
          } else {
            this.$message.error(res.data.message);
            if (res.data.code == 403) {
              this.$router.push({ path: "loginAdmin" });
            }
          }
          this.addLoading = false;
        })
        .catch((err) => {
          this.$message.error("数据丢失，试试重新登陆！");
          this.addLoading = false;
        });
    },

    // 重置表单
    resetForm(formName) {
      this.imageUrl = "";
      this.editImageUrl = "";
      this.$refs[formName].resetFields();
    },

    // 关闭弹框
    handerClose(visibleFlag, formRef) {
      this[visibleFlag] = false;
      this.resetForm(formRef);
    },

    handleDel: function (index, row) {
      this.$confirm("确认删除吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          let para = {
            token: this.token,
            checkCode: this.checkCode,
            id: row.id,
          };
          API_User.delCompanyList(para)
            .then((res) => {
              if (res.data.code == API__code.SUCCESS) {
                this.$message({
                  message: "删除成功",
                  type: "success",
                });
                this.getList();
              } else {
                this.$message.error(res.data.message);
                if (res.data.code == 403) {
                  this.$router.push({ path: "loginAdmin" });
                }
              }
            })
            .catch((err) => {
              this.$message.error("数据丢失，试试重新登陆！");
            });
        })
        .catch((err) => { });
    },
    handleCom: function (index, row) {
      this.$router.push({
        path: "/userCom",
        query: {
          companyId: row.id,
          managerId: row.managerid,
          companyName: row.name,
          isbinding: row.isbinding,
          dynamicTags: JSON.stringify(this.dynamicTags),
          souchs: JSON.stringify(this.souchs),
          searchText: this.searchText,
          distributionStatus: this.distributionStatus,
          managerAdminuser: this.managerAdminuser,
          status: this.status,
          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
          regionCode: this.regionCode,
          successfulManager:this.successfulManager,
          agencyManager:this.agencyManager,
          distributionStatus: this.distributionStatus,
          gradeValue: this.gradeValue.length ? this.gradeValue.join(',') : '',
        },
      });
    },
    handleEdit: function (index, row) {
      this.beformAddImg = "";
      this.editFormVisible = true;
      this.editImageUrl = row.pic;
      this.editForm = Object.assign({}, row);

      this.editFormVisible = true;
    },
    handleAdd: function () {
      // this.addForm = {}
      // this.addFormVisible = true
      // this.addLoading = false
      this.$refs.targetcustomdialogRef.init();
    },
    delTags: function () {
      (this.souchs = {}), (this.value = "");
      this.proName = "";
      this.dynamicTags = [];
      this.pageNumber = 1;
      this.getList();
    },
    handleClose(tag) {
      if (tag == "ID") {
        this.souchs.id = "";
        if (this.value == "ID") {
          this.proName = "";
        }
      }
      if (tag == "企业名称") {
        this.souchs.company = "";
        if (this.value == "企业名称") {
          this.proName = "";
        }
      }
      if (tag == "管理员") {
        this.souchs.managername = "";
        if (this.value == "管理员") {
          this.proName = "";
        }
      }
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },
    changeSouch: function (val) {
      if (val == "ID") {
        this.proName = this.souchs.id;
      } else if (val == "企业名称") {
        this.proName = this.souchs.company;
      } else if (val == "管理员") {
        this.proName = this.souchs.managername;
      }
    },
    getList: function (val) {
      // 仅主动查询(getList(1))时清空已选，普通翻页不清空
      this.needClearSel = val == 1;
      if (this.value == "ID") {
        this.souchs.id = this.proName;
      }
      if (this.value == "企业名称") {
        this.souchs.company = this.proName;
      }
      if (this.value == "管理员") {
        this.souchs.managername = this.proName;
      }
      var flag = true;
      if (val == 1) {
        this.pageNumber = 1;
        if (this.value) {
          if (this.dynamicTags.length > 0) {
            for (var i = 0; i < this.dynamicTags.length; i++) {
              if (this.value == this.dynamicTags[i]) {
                flag = false;
              }
            }
          }
          if (flag) {
            this.dynamicTags.push(this.value);
          }
        }
      }
      let param = {
        // token: this.token,
        // checkCode: this.checkCode,
        listType: "page",
        pageSize: this.pageSize,
        pageNumber: this.pageNumber,
        managename: this.souchs.managename,
        id: this.souchs.id,
        company: this.souchs.company,
        fpFlg: this.distributionStatus,
        orderType: this.orderType,
        orderStr: this.orderStr,
        role: this.userInfo.type,
        userId: this.userInfo.id,
        managerAdminuser: this.managerAdminuser,
        searchText: this.searchText,
        status: 1,
        regionCode: this.regionCode,
        successfulManager:this.successfulManager,
        agencyManager:this.agencyManager,
        userType:this.userInfo.type,
        grade:this.gradeValue.length ? this.gradeValue.join(',') : '',
      };
      this.listLoading = true;
      // console.log('param', param)
      // debugger
      API_User.companyList(param)
        .then((res) => {
          if (res.data.code == API__code.SUCCESS) {
            if (res.data) {
              this.total = res.data.data.totalRow;
              this.proList = res.data.data.list;
              this.targetTotal = res.data.c1;
              this.qualityTotal = res.data.c2;
              this.collegesTotal=res.data.c4
              if (this.needClearSel && this.$refs.companyTable) {
                // 重新查询后清空跨页保留的选中项（触发 selection-change，list 自动置空）
                this.$refs.companyTable.clearSelection();
              }
            }
          } else {
            this.$message.error(res.data.message);
            if (res.data.code == 403) {
              this.$router.push({ path: "loginAdmin" });
            }
          }
          this.listLoading = false;
        })
        .catch((err) => {
          this.$message.error("数据丢失，试试重新登陆！");
          this.listLoading = false;
        });
    },
    indexMethod(index) {
      return index + 1 + (this.pageNumber - 1) * pageSize;
    },
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if (rowIndex == 0) {
        return "background:#F5F7FA";
      } else {
        return "";
      }
    },
    selsChange: function (sels) {
      this.sels = sels;
      this.exportList = sels;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pageNumber = val;
      this.getList();
    },
    //读取cookie
    getCookie: function () {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split("; "); //这里显示的格式需要切割一下自己可输出看下
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split("="); //再次切割
          //判断查找相对应的值
          if (arr2[0] == "dnnyptadmin_token") {
            this.token = arr2[1]; //保存到保存数据的地方
          } else if (arr2[0] == "dnnyptadmin_checkCode") {
            this.checkCode = arr2[1];
          } else if (arr2[0] == "dnnyptadmin_id") {
            this.id = arr2[1];
          }
        }
      }
    },
    getCode1: function () {
      let _this = this;
      let param = {
        token: this.token,
        checkCode: this.checkCode,
      };
      API_Admin.UserList(param).then((res) => {
        if (res.data.code == API__code.SUCCESS) {
          // this.yhlx = res.data.data;
          _this.yhlx = [];
          _this.softtypes = [];
          for (var i = 0; i < res.data.data.length; i++) {
            var jsons = {
              value: res.data.data[i].code,
              text: res.data.data[i].name,
            };
            _this.yhlx.push(jsons);
            var json = {
              value: res.data.data[i].code,
              label: res.data.data[i].name,
            };
            _this.softtypes.push(json);
          }
        } else {
          this.$message.error(res.data.message);
          if (res.data.code == 403) {
            this.$router.push({ path: "loginAdmin" });
          }
        }
      });
    },
    getCode: function () {
      let _this = this;
      let param = {
        token: this.token,
        checkCode: this.checkCode,
        type: 7,
      };
      API_User.getCode(param).then((res) => {
        if (res.data.code == API__code.SUCCESS) {
          _this.inviValues = [];
          for (var i = 0; i < res.data.data.length; i++) {
            var jsons = {
              value: res.data.data[i].code,
              label: res.data.data[i].name,
            };
            _this.inviValues.push(jsons);
          }
        } else {
          this.$message.error(res.data.message);
          if (res.data.code == 403) {
            this.$router.push({ path: "loginAdmin" });
          }
        }
      });
    },
    backPram(param) {
      this.addForm.province = JSON.stringify(param.selected.province);
      this.addForm.city = JSON.stringify(param.selected.city);
      this.addForm.district = JSON.stringify(param.selected.area);
      this.addForm.longitudeAndLatitude = param.position.toString();
      this.addForm.addressInfo = param.address;
    },
  },
  mounted() {
    console.log(this.$route.query.distributionStatus);
    // this.getUser();
  },
  created() {
    this.getCookie();
    // this.loadCompany();
    this.initSearchParams()
    if (this.$route.query.type == 1) {
      this.dynamicTags = JSON.parse(this.$route.query.dynamicTags);
      this.souchs = JSON.parse(this.$route.query.souchs);
      this.pageNumber = JSON.parse(this.$route.query.pageNumber);
    }
    this.getList();
    // this.getCode()
    // this.getCode1()
  },
};
</script>

<style lang="scss">
.dnnCloud-company-box {
  .base-container-bd {
    .content-hd {
      .el-form-item {
        margin-bottom: 0;
      }
    }
  }

  .avatar-uploader-icon {
    width: 120px;
    height: 120px;
    line-height: 120px;
  }

  .avatar {
    width: 120px;
    height: 120px;
  }
}

// 导入失败明细弹窗：内容区固定高度500px，超出部分纵向滚动
.import-fail-alert {
  .el-message-box__content {
    max-height: 500px;
    overflow-y: auto;
  }
}
</style>
<style lang="scss" scoped>
.el-select {
  display: inline-block;
  position: relative;
  width: 115px;
}

.el-tag+.el-tag {
  margin-left: 10px;
}

.map {
  width: 100%;
  height: 750px;
}

.caozuo {
  cursor: pointer;
  margin-right: 12px;
}

.tips {
  font-size: 14px;
  line-height: 22px;
  color: #666666;
  margin-bottom: 14px;

  .blueNumber {
    color: #669df0;
    margin-right: 32px;
  }

  .redNumber {
    color: #eb6264;
    margin-right: 32px;
  }

  .colleges {
    color: #7FDDA5;
  }
}

.gray {
  // width: 60px;
  width: 80px;
  text-align: center;
  padding: 3px 12px 3px 12px;
  border: 1px solid #d3d4d6;
  color: #909399;
  border-radius: 2px;
}

.visit_gray {
  width: 60px;
  text-align: center;
  padding: 3px 12px 3px 12px;
  border: 1px solid #d3d4d6;
  color: #909399;
  border-radius: 2px;
}

.blue {
  min-width: 60px;
  max-width: 94px;
  text-align: center;
  padding: 3px 12px 3px 12px;
  background: #f1f5ff;
  color: #669df0;
  border-radius: 2px;
}

.purple {
  min-width: 60px;
  max-width: 94px;
  text-align: center;
  padding: 3px 12px 3px 12px;
  background: #f8f1fb;
  color: #be74d9;
  border-radius: 2px;
}

.other {
  min-width: 60px;
  max-width: 94px;
  text-align: center;
  padding: 3px 12px 3px 12px;
  color: #666666;
  border-radius: 2px;
  background: #f7f7f7;
}

.blue_line {
  width: 60px;
  text-align: center;
  padding: 3px 12px 3px 12px;
  border: 1px solid #669df0;
  color: #669df0;
  border-radius: 2px;
}

.purple_line {
  width: 60px;
  text-align: center;
  padding: 3px 12px 3px 12px;
  border: 1px solid #be74d9;
  color: #be74d9;
  border-radius: 2px;
}

.orange {
  width: 60px;
  text-align: center;
  padding: 3px 12px 3px 12px;
  border: 1px solid #fd945a;
  color: #fd945a;
  border-radius: 2px;
}
</style>



// WEBPACK FOOTER //
// Company.vue?63809696